import { Component } from '@angular/core';
import { LoginService } from './login.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import 'rxjs/add/operator/finally';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
	constructor(private app: LoginService, private http: HttpClient, private router: Router) {    }

    logout() {
      localStorage.removeItem('auth_token');
 
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts